import { Grid, Tooltip, Typography } from '@mui/material';
import PromotionTooltipContent from './PromotionTooltipContent';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import { useTranslation } from 'next-i18next';

interface PromotionTooltipProps {
  promotions: Array<any>;
  showTitle?: boolean;
}

const PromotionTooltip = ({ promotions, showTitle }: PromotionTooltipProps) => {
  const { t } = useTranslation('common');
  const hasValidPromotion =
    promotions.filter((promotion) => promotion.validNow).length > 0;
  return hasValidPromotion ? (
    <Tooltip
      title={<PromotionTooltipContent promotions={promotions} />}
      enterTouchDelay={0}
    >
      <Grid container alignItems="center" justifyContent="center">
        <Grid item>
          <LoyaltyIcon />
        </Grid>
        {showTitle && (
          <Grid item>
            <Typography variant="subtitle2">{t('voucherTitle')}</Typography>
          </Grid>
        )}
      </Grid>
    </Tooltip>
  ) : (
    <></>
  );
};

export default PromotionTooltip;
